// extracted by mini-css-extract-plugin
module.exports = {"you__covered":"HeadingWithIconButton_you__covered__Bx8Ty"};